import React from 'react';
import { Button, Glyphicon } from 'react-bootstrap';

const CancelIconButton = props => (
	<Button bsStyle='danger' bsSize='xsmall' {...props}>
		<Glyphicon glyph='remove' />
	</Button>
);

export default CancelIconButton;